import Exercise from '@/api/exercise';
import Lesson from '@/api/lesson';
import Program from '@/api/program';
import EntityView from '@/views/EntityView.vue';
import ExerciseView from '@/views/ExerciseView.vue';
import { ExerciseGameType } from '@/api/common';
import ProgramView from '@/views/ProgramView.vue';
import Submodule from '@/api/submodule';

export const PROGRAM_ROUTE = [
  {
    path: `/${Program.SLUG}/`,
    name: `${Program.SLUG}-list`,
    component: EntityView,
    props: () => ({
      entity: Program.SLUG
    }),
    meta: {
      title: 'Program · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/new`,
    name: `${Program.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Program.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Module · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:id(\\d+)`,
    name: `${Program.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Program.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Program · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:id(\\d+)/${Lesson.SLUG}`,
    name: `${Program.SLUG}-${Lesson.SLUG}-list`,
    component: ProgramView,
    props: (route) => ({
      entity: Lesson.SLUG,
      programId: parseInt(route.params.id, 10)
    }),
    meta: {
      title: 'Lessons · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:id(\\d+)/${Lesson.SLUG}/new`,
    name: `${Program.SLUG}-${Lesson.SLUG}-new`,
    component: ProgramView,
    props: (route) => ({
      entity: Lesson.SLUG,
      programId: parseInt(route.params.id, 10),
      isNew: true,
      isEdit: true
    }),
    meta: {
      title: 'New Lesson · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:programId(\\d+)/${Lesson.SLUG}/:lessonId(\\d+)`,
    name: `${Program.SLUG}-${Lesson.SLUG}-edit`,
    component: ProgramView,
    props: (route) => ({
      entity: Lesson.SLUG,
      programId: parseInt(route.params.programId, 10),
      id: parseInt(route.params.lessonId, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Lesson · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:id(\\d+)/${Submodule.SLUG}/new`,
    name: `/${Program.SLUG}-${Submodule.SLUG}-new`,
    component: ProgramView,
    props: (route) => ({
      entity: Submodule.SLUG,
      programId: parseInt(route.params.id, 10),
      isNew: true,
      isEdit: true
    }),
    meta: {
      title: 'New Submodule · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:programId(\\d+)/${Submodule.SLUG}/:id(\\d+)`,
    name: `${Submodule.SLUG}-edit`,
    component: ProgramView,
    props: (route) => ({
      entity: Submodule.SLUG,
      programId: parseInt(route.params.programId, 10),
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Submodule · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:programId(\\d+)/${Lesson.SLUG}/:lessonId(\\d+)/${Exercise.SLUG}`,
    name: `${Program.SLUG}-${Exercise.SLUG}-list`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.programId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      parent: Program.SLUG,
      isProgram: true
    }),
    meta: {
      title: 'Exercises · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:programId(\\d+)/${
      Lesson.SLUG
    }/:lessonId(\\d+)/:gametype(${ExerciseGameType.regex()})`,
    name: `${Program.SLUG}-${Exercise.SLUG}-new`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.programId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      gameType: ExerciseGameType.slugToType(route.params.gametype),
      isNew: true,
      isEdit: true,
      parent: Program.SLUG,
      isProgram: true
    }),
    meta: {
      title: 'New Exercise · ELSA Content Creator'
    }
  },
  {
    path: `/${Program.SLUG}/:programId(\\d+)/${
      Lesson.SLUG
    }/:lessonId(\\d+)/:gametype(${ExerciseGameType.regex()})/:exerciseId(\\d+)`,
    name: `${Program.SLUG}-${Exercise.SLUG}-edit`,
    component: ExerciseView,
    props: (route) => ({
      moduleId: parseInt(route.params.programId, 10),
      lessonId: parseInt(route.params.lessonId, 10),
      id: parseInt(route.params.exerciseId, 10),
      gameType: ExerciseGameType.slugToType(route.params.gametype),
      isEdit: true,
      parent: Program.SLUG,
      isProgram: true
    }),
    meta: {
      title: 'Edit Exercise · ELSA Content Creator'
    }
  }
];
